var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pagination-trigger",on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.pageNumber))])}
var staticRenderFns = []

export { render, staticRenderFns }